import Axios from "axios";
import {
  SET_PRODUCTION_ORDER_LIST,
  UNSET_PRODUCTION_ORDER_LIST,
} from "@/store/mutation-types";

import { productionOrderResource } from "@/store/api";

const state = {
  getProductionOrderList: [],
};

const getters = {
  getProductionOrderList(state) {
    return state.getProductionOrderList;
  },
};

const mutations = {
  [SET_PRODUCTION_ORDER_LIST](state, data) {
    state.getProductionOrderList = data;
  },
  [UNSET_PRODUCTION_ORDER_LIST](state) {
    state.getProductionOrderList = [];
  },
};

const actions = {

    getProductionOrderList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
        Axios.get(productionOrderResource, { params })
            .then((response) => {
            commit(SET_PRODUCTION_ORDER_LIST, response.data.data);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_PRODUCTION_ORDER_LIST);
            reject(error);
            });
        });
    },

    saveProductionOrder({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.post(productionOrderResource, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    updateProductionOrder({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${productionOrderResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.put(url, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    getProductionOrderById({ commit }, { id }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${productionOrderResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.get(url)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

};

export default {
  state,
  getters,
  actions,
  mutations,
};

